import { motion } from "framer-motion";
import { Bell, Home, Layers, Wallet } from "lucide-react";

const Sparkline = () => (
  <svg viewBox="0 0 220 72" className="w-full h-16" fill="none">
    <defs>
      <linearGradient id="sparkGold" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#8a6d1c" />
        <stop offset="55%" stopColor="#D4AF37" />
        <stop offset="100%" stopColor="#F3E5AB" />
      </linearGradient>
      <linearGradient id="sparkFill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="rgba(212,175,55,0.25)" />
        <stop offset="100%" stopColor="rgba(212,175,55,0)" />
      </linearGradient>
    </defs>
    <path
      d="M0,58 C18,54 28,40 46,44 C64,48 74,30 94,33 C114,36 124,20 144,23 C164,26 176,12 196,15 C206,17 214,10 220,8 L220,72 L0,72 Z"
      fill="url(#sparkFill)"
    />
    <motion.path
      d="M0,58 C18,54 28,40 46,44 C64,48 74,30 94,33 C114,36 124,20 144,23 C164,26 176,12 196,15 C206,17 214,10 220,8"
      stroke="url(#sparkGold)"
      strokeWidth="2"
      strokeLinecap="round"
      initial={{ pathLength: 0 }}
      whileInView={{ pathLength: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 2, ease: "easeInOut" }}
    />
  </svg>
);

const ProductRow = ({ name, meta, change, positive }) => (
  <div className="flex items-center justify-between rounded-xl bg-white/[0.04] border border-white/[0.06] px-3.5 py-3">
    <div>
      <p className="text-[13px] font-medium text-white">{name}</p>
      <p className="text-[10px] font-mono tracking-wider text-[#636B78] uppercase mt-0.5">{meta}</p>
    </div>
    <span className={`text-[13px] font-mono font-semibold ${positive ? "text-emerald-400" : "text-[#99A1AF]"}`}>
      {change}
    </span>
  </div>
);

export default function PhoneMockup() {
  return (
    <div
      className="relative w-[290px] sm:w-[320px] rounded-[2.8rem] border border-white/15 bg-[#0F0F13] p-2.5 shadow-[0_40px_120px_rgba(0,0,0,0.75),0_0_80px_rgba(212,175,55,0.07)]"
      data-testid="app-phone-mockup"
    >
      <div className="rounded-[2.2rem] overflow-hidden bg-[#0A0A0E] border border-white/[0.06]">
        <div className="px-5 pt-4 pb-1 flex items-center justify-between">
          <span className="font-mono text-[10px] text-[#636B78]">9:41</span>
          <div className="h-4 w-16 rounded-full bg-black border border-white/10" />
          <div className="flex gap-1">
            <span className="h-1.5 w-1.5 rounded-full bg-[#636B78]" />
            <span className="h-1.5 w-1.5 rounded-full bg-[#636B78]" />
          </div>
        </div>

        <div className="px-5 pt-3 pb-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img src="/winter-logo.jpg" alt="Winter Protocol" className="h-7 w-7 rounded-md object-cover mix-blend-screen" />
              <span className="font-display text-[11px] font-bold tracking-[0.2em] text-white">WINTER</span>
            </div>
            <Bell className="h-4 w-4 text-[#99A1AF]" />
          </div>

          <div className="mt-5">
            <p className="font-mono text-[9px] tracking-[0.25em] text-[#636B78] uppercase">Total Balance</p>
            <p className="mt-1 font-display text-3xl font-bold text-white tracking-tight">$24,860.42</p>
            <p className="mt-1 text-[11px] font-mono text-emerald-400">+2.4% this week</p>
          </div>

          <div className="mt-3 rounded-xl border border-white/[0.06] bg-white/[0.03] p-2">
            <Sparkline />
          </div>

          <div className="mt-4 space-y-2">
            <ProductRow name="Winter Alpha" meta="AI Momentum" change="+3.8%" positive />
            <ProductRow name="Winter Yield Max" meta="Weekly payout" change="+1.2%" positive />
          </div>

          <div className="mt-4 flex items-center justify-between rounded-full bg-[#D4AF37] px-5 py-3">
            <span className="text-[12px] font-semibold text-[#08080A]">Explore AI Products</span>
            <span className="text-[#08080A] text-sm">→</span>
          </div>
        </div>

        <div className="flex items-center justify-around border-t border-white/[0.06] px-6 py-3.5">
          <Home className="h-4.5 w-4.5 h-[18px] w-[18px] text-[#D4AF37]" />
          <Layers className="h-[18px] w-[18px] text-[#636B78]" />
          <Wallet className="h-[18px] w-[18px] text-[#636B78]" />
        </div>
      </div>
    </div>
  );
}
